var _classCallCheck = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/createClass");

var RuntimeError = require('./RuntimeError');

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function _class() {
    _classCallCheck(this, _class);

    this.memory_stack = [new Map()];
    this.global = this.memory_stack[0];
  }

  _createClass(_class, [{
    key: "push",
    value: function push() {
      this.memory_stack.push(new Map());
    }
  }, {
    key: "pop",
    value: function pop() {
      this.memory_stack.pop();
    }
  }, {
    key: "top",
    value: function top() {
      return this.memory_stack.length ? this.memory_stack[this.memory_stack.length - 1] : false;
    }
  }, {
    key: "getVar",
    value: function getVar(name) {
      for (var i = this.memory_stack.length - 1; i >= 0; i--) {
        if (this.memory_stack[i].has(name)) return this.memory_stack[i].get(name);
      }

      return undefined;
    }
  }, {
    key: "declareVar",
    value: function declareVar(name) {
      this.top().set(name, undefined);
    }
  }, {
    key: "setVar",
    value: function setVar(name, value) {
      for (var i = this.memory_stack.length - 1; i >= 0; i--) {
        if (this.memory_stack[i].has(name)) return this.memory_stack[i].set(name, value);
      }

      this.global.set(name, value);
    }
  }, {
    key: "hasLocalVar",
    value: function hasLocalVar(name) {
      return this.top().has(name);
    }
  }]);

  return _class;
}();